export const getSlaStageStyle = (stage) => {
  switch (stage) {
    case "WithinSla":
      return { label: "Within SLA", bg: "#2A9D8F" }; // green

    case "AboutToBreach":
      return { label: "About to Breach", bg: "#f59e0b" }; // orange

    case "Breached":
    case "BreachEscalation":
      return { label: "Breached Escalation", bg: "#E63946" }; // red

    default:
      return { label: "-", bg: "transparent" };
  }
};
